import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HeroSlider = ({ language }) => {
  const slides = [
    {
      video: '/hero-desert-voyages.mp4',
      title: {
        fr: 'Explorez. Innovez. Connectez-vous.',
        en: 'Explore. Innovate. Connect.',
        ar: 'استكشف. ابتكر. تواصل.'
      },
      subtitle: {
        fr: 'Votre partenaire de confiance pour vos voyages et votre transformation digitale depuis Oman.',
        en: 'Your trusted partner for travel and digital transformation from Oman.',
        ar: 'شريكك الموثوق للسفر والتحول الرقمي من عمان.'
      }
    },
    {
      image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1600&q=80',
      title: {
        fr: 'Voyages sur mesure',
        en: 'Custom travels',
        ar: 'رحلات مخصصة'
      },
      subtitle: {
        fr: 'Des expériences de voyage uniques conçues spécialement pour vous.',
        en: 'Unique travel experiences designed especially for you.',
        ar: 'تجارب سفر فريدة مصممة خصيصًا لك.'
      }
    },
    {
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1600&q=80',
      title: {
        fr: 'Solutions digitales innovantes',
        en: 'Innovative digital solutions',
        ar: 'حلول رقمية مبتكرة'
      },
      subtitle: {
        fr: 'Transformez votre entreprise avec nos technologies de pointe.',
        en: 'Transform your business with our cutting-edge technologies.',
        ar: 'حوّل عملك بتقنياتنا المتطورة.'
      }
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    fade: true,
    pauseOnHover: false,
    arrows: true,
  };

  return (
    <div className="hero-slider">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <section className="relative h-[600px] overflow-hidden">
              <div className="absolute inset-0">
                {slide.video ? (
                  <video
                    src={slide.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <img
                    src={slide.image}
                    alt={`Slide ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
              </div>

              <div className="container mx-auto px-4 lg:px-8 h-full relative z-10 flex items-center">
                <div className="max-w-2xl text-white">
                  <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight animate-fade-in">
                    {slide.title[language]}
                  </h1>
                  <p className="text-xl md:text-2xl mb-8 text-gray-100 leading-relaxed animate-fade-in">
                    {slide.subtitle[language]}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 animate-fade-in">
                    <Link
                      to="/voyages"
                      className="inline-flex items-center justify-center space-x-2 bg-maquette-blue text-white px-8 py-4 rounded-md font-semibold hover:bg-maquette-dark transition-all shadow-lg"
                    >
                      <span>
                        {language === 'fr' && 'Voir nos voyages'}
                        {language === 'en' && 'See our travels'}
                        {language === 'ar' && 'شاهد رحلاتنا'}
                      </span>
                      <ArrowRight size={20} />
                    </Link>
                    <Link
                      to="/it-services"
                      className="inline-flex items-center justify-center space-x-2 bg-white text-maquette-blue px-8 py-4 rounded-md font-semibold hover:bg-gray-100 transition-all shadow-lg border border-white"
                    >
                      <span>
                        {language === 'fr' && 'Découvrir nos services IT'}
                        {language === 'en' && 'Discover our IT services'}
                        {language === 'ar' && 'اكتشف خدماتنا التقنية'}
                      </span>
                      <ArrowRight size={20} />
                    </Link>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSlider;